import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
//
export default props => {
  const { imagelink, videolink } = props;

  return (
    <Wrap>
      {imagelink && !videolink && <Image src={imagelink} />}

      {videolink && (
        <ReactPlayer
          className="react-player"
          height={"auto"}
          loop
          muted
          playing
          width={"100%"}
          url={[videolink]}
        />
      )}
    </Wrap>
  );
};
//
const Wrap = styled.div`
  line-height: 0;
  margin: 0;
  padding: 0 0 1vw;
  width: 100%;
`;

const Image = styled.img`
  height: auto;
  width: 100%;
`;
